
import "../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_189_1_HorizontalScroll";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_189_1_HorizontalScroll__root","scrollContainer":"wds_1_189_1_HorizontalScroll__scrollContainer","startScroll":"wds_1_189_1_HorizontalScroll__startScroll","endScroll":"wds_1_189_1_HorizontalScroll__endScroll","startScrollButton":"wds_1_189_1_HorizontalScroll__startScrollButton","endScrollButton":"wds_1_189_1_HorizontalScroll__endScrollButton"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-space-100":"--wds-space-100","wds-space-600":"--wds-space-600","wds-horizontal-scroll-gradient-color":"--wds-horizontal-scroll-gradient-color"}; 




